module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || '98lydf3o',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
